import DOMPurify from "isomorphic-dompurify";
import type { ComponentPropsWithRef, ElementType } from "react";

export type SanitizedContentProps<C extends ElementType = "div"> = Omit<ComponentPropsWithRef<C>, "children"> & {
  as?: C;
  content: string;
};

export function SanitizedContent<C extends ElementType = "div">({ as, content, ...props }: SanitizedContentProps<C>) {
  const Component = as || "div";

  // biome-ignore lint/security/noDangerouslySetInnerHtml: fine as we sanitize the content
  return <Component {...props} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />;
}
